// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__e0-Sx","list":"BalanceDue_list__3NvcI","listRow":"BalanceDue_listRow__2CanC","total":"BalanceDue_total__1mHs4"};